<script lang="ts">
	import Icon from '../Icon.svelte';
	import ImportDataModal from './ImportDataModal.svelte';
	import { _ } from 'svelte-i18n';

	interface Props {
		disableUpload?: boolean;
		uploadName: string;
		acceptedFileTypes: string;
		warnings: string[][];
		downloadLink?: string | null;
		fileTypeCheck: (type: String) => Boolean;
		confirmFunction: (
			uploadName: string,
			objectName: string,
			isOnlyUpdate: boolean
		) => Promise<void>;
		header: string;
		uploadDescription: string;
		isOnlyUpdateText: string;
		isInsertText: string;
		onModalClose: () => void;
	}

	let {
		disableUpload = false,
		uploadName,
		acceptedFileTypes,
		warnings,
		downloadLink = null,
		fileTypeCheck,
		confirmFunction,
		header,
		uploadDescription,
		isOnlyUpdateText,
		isInsertText,
		onModalClose
	}: Props = $props();

	let isOnlyUpdate: boolean = $state(true);

	let selectedWarnings = $derived(isOnlyUpdate ? warnings[0] : warnings[1]);
</script>

<ImportDataModal
	{onModalClose}
	{uploadName}
	{acceptedFileTypes}
	{disableUpload}
	warnings={selectedWarnings}
	{downloadLink}
	{header}
	{uploadDescription}
	{fileTypeCheck}
	confirmFunction={async (uploadName, objectName) => {
		await confirmFunction(uploadName, objectName, isOnlyUpdate);
	}}
>
	{#snippet additionContent()}
		<div class="pt-8 pb-4">
			<p class="text-center text-lg text-secondary-100 pb-2">
				{isOnlyUpdate ? isOnlyUpdateText : isInsertText}
			</p>
			<div class="flex gap-4 justify-center">
				<button
					onclick={() => {
						isOnlyUpdate = true;
					}}
					class="border-2 border-secondary-200 dark:border-secondary-500 {isOnlyUpdate
						? 'bg-secondary-200 dark:bg-secondary-500 fill-white'
						: ' fill-secondary-200 dark:fill-secondary-500 hover:bg-secondary-200 dark:hover:bg-secondary-500 hover:fill-white'} p-8 rounded"
				>
					<Icon name="arrows-rotate"></Icon>
				</button>

				<button
					onclick={() => {
						isOnlyUpdate = false;
					}}
					class="border-2 border-secondary-200 dark:border-secondary-500 {isOnlyUpdate
						? ' fill-secondary-200 dark:fill-secondary-500 hover:bg-secondary-200 dark:hover:bg-secondary-500 hover:fill-white'
						: 'bg-secondary-200 dark:bg-secondary-500 fill-white'} p-8 rounded"
				>
					<Icon name="plus"></Icon>
				</button>
			</div>
		</div>
	{/snippet}
</ImportDataModal>
